import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, money } from "@/lib/api";
import { ProgressBar, TrustChips } from "@/components/shared";
import { Heart, Loader2, ShieldCheck } from "lucide-react";
import logoUrl from "@/assets/fightfund-logo.png";

export default function Embed() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  const [cryptoOn, setCryptoOn] = useState(true);

  useEffect(() => {
    api.get(`/campaigns/${slug}`).then((r) => setC(r.data)).catch(() => setErr(true));
    api.get("/settings/public").then((r) => setCryptoOn(r.data.crypto_enabled !== false)).catch(() => {});
  }, [slug]);

  const donateUrl = `/fundraisers/${slug}/donate`;

  if (err) return <div className="flex h-screen items-center justify-center text-sm text-ff-medium">Campaign unavailable</div>;
  if (!c) return <div className="flex h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-ff-red" /></div>;

  return (
    <div className="flex min-h-[440px] flex-col bg-white p-4 font-sans">
      <div className="flex items-center gap-2">
        <img src={logoUrl} alt="FightFund" className="h-6 w-6" />
        <span className="font-heading text-sm font-extrabold text-ff-blue">Fight<span className="text-ff-red">Fund</span></span>
      </div>
      {c.cover_image && <div className="mt-3 overflow-hidden rounded-lg"><img src={c.cover_image} alt={c.title} className="h-28 w-full object-cover" /></div>}
      <h1 className="mt-3 font-heading text-base font-bold leading-snug text-ff-blue line-clamp-2">{c.title}</h1>
      <div className="mt-3"><ProgressBar raised={c.amount_raised} goal={c.goal_amount} /></div>
      <div className="mt-2"><TrustChips labels={(c.trust_labels || []).slice(0, 1)} /></div>
      <a href={donateUrl} target="_top" data-testid="embed-donate"
        className="mt-auto flex items-center justify-center gap-2 rounded-lg bg-ff-action py-3 text-sm font-bold text-white hover:bg-ff-actionDark">
        <Heart className="h-4 w-4" /> Donate now
      </a>
      <div className="mt-2 flex items-center justify-center gap-1 text-[10px] text-ff-medium" data-testid="embed-footer">
        <ShieldCheck className="h-3 w-3 text-ff-green" /> Reviewed before payout · Secured by Stripe{cryptoOn ? " · Crypto accepted" : ""}
      </div>
    </div>
  );
}
